import { isEmpty } from 'ramda'

import { defaultStateDataCurrent } from 'app/common/ui-components/filter'
import { GET_SALE_TYPES, convertResult } from 'app/common/api/requests/food/items/sale_types/get'
import { api } from 'app/api'


export const saleTypeItems = async () => {
  const res = await api.request(GET_SALE_TYPES, {
    error: 'Не удалось получить данные типов продукции',
    convertions: {
      convertResult,
    },
  })

  if (res && !isEmpty(res)) {
    const items = res
    return ([items, defaultStateDataCurrent])
  }
  return [[], defaultStateDataCurrent]
}
